import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "top-matter" }
const _hoisted_2 = { class: "right-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShareIcon = _resolveComponent("ShareIcon")!
  const _component_HomeIcon = _resolveComponent("HomeIcon")!
  const _component_NcBreadcrumb = _resolveComponent("NcBreadcrumb")!
  const _component_NcBreadcrumbs = _resolveComponent("NcBreadcrumbs")!
  const _component_PublicUploadHandler = _resolveComponent("PublicUploadHandler")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_UploadIcon = _resolveComponent("UploadIcon")!
  const _component_FoldersIcon = _resolveComponent("FoldersIcon")!
  const _component_TimelineIcon = _resolveComponent("TimelineIcon")!
  const _component_NcActions = _resolveComponent("NcActions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_component_NcBreadcrumbs, {
      key: _ctx.$route.path
    }, {
      default: _withCtx(() => [
        _createVNode(_component_NcBreadcrumb, {
          name: _ctx.rootFolderName,
          to: _ctx.getRoute([]),
          "force-icon-text": _ctx.routeIsPublic
        }, {
          icon: _withCtx(() => [
            (_ctx.routeIsPublic)
              ? (_openBlock(), _createBlock(_component_ShareIcon, {
                  key: 0,
                  size: 20
                }))
              : (_openBlock(), _createBlock(_component_HomeIcon, {
                  key: 1,
                  size: 20
                }))
          ]),
          _: 1
        }, 8, ["name", "to", "force-icon-text"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (folder) => {
          return (_openBlock(), _createBlock(_component_NcBreadcrumb, {
            key: folder.idx,
            name: folder.text,
            to: _ctx.getRoute(folder.path)
          }, null, 8, ["name", "to"]))
        }), 128))
      ]),
      _: 1
    })),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.allowPublicUpload)
        ? (_openBlock(), _createBlock(_component_PublicUploadHandler, {
            key: 0,
            ref: "uploadHandler"
          }, null, 512))
        : _createCommentVNode("", true),
      _createVNode(_component_NcActions, { inline: 3 }, {
        default: _withCtx(() => [
          (!_ctx.routeIsPublic)
            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                key: 0,
                "aria-label": _ctx.t('memories', 'Share folder'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.share())),
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_ShareIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Share folder')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label"]))
            : _createCommentVNode("", true),
          (!_ctx.routeIsPublic)
            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                key: 1,
                "aria-label": _ctx.t('memories', 'Upload files'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.upload())),
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_UploadIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Upload files')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label"]))
            : _createCommentVNode("", true),
          (_ctx.allowPublicUpload)
            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                key: 2,
                "aria-label": _ctx.t('memories', 'Upload files'),
                disabled: _ctx.uploadHandler()?.processing,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.uploadHandler()?.startUpload()))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_UploadIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Upload files')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "disabled"]))
            : _createCommentVNode("", true),
          _createVNode(_component_NcActionButton, {
            onClick: _ctx.toggleRecursive,
            "close-after-click": ""
          }, {
            icon: _withCtx(() => [
              (_ctx.recursive)
                ? (_openBlock(), _createBlock(_component_FoldersIcon, {
                    key: 0,
                    size: 20
                  }))
                : (_openBlock(), _createBlock(_component_TimelineIcon, {
                    key: 1,
                    size: 20
                  }))
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.recursive ? _ctx.t('memories', 'Folder view') : _ctx.t('memories', 'Timeline view')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ])
  ]))
}